import axios from "axios";
import config from "../../../config";
export interface Tenant {
  id: number;
  esKey: string;
  zohoCustomerName?: string | null;
}
export interface TenantListFilter {
  limit: number;
  tenantId?: number | undefined;
  tenant?: string | undefined;
}
const { apiServerUrl } = config;

export const getAccessibleTenantList = async (
  filters: TenantListFilter
): Promise<Tenant[]> => {
  try {
    const response = await axios.post<Tenant[]>(
      `${apiServerUrl}/users/tenant/list`,
      filters
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Failed to fetch tenant list"
      );
    }
    throw error;
  }
};

export const updateTenant = async (tenantId: number) => {
  try {
    const response = await axios.put(`${apiServerUrl}/users/tenant/access`, {
      tenantId,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Failed to fetch tenant list"
      );
    }
    throw error;
  }
};
